export enum MatchEndRule {
  ByAge = 'ByAge',
  Hantei = 'Hantei',
  GoldenScore = 'GoldenScore',
}

type AgeLimit = {
  maxAge?: number | null;
  isOpenEnded?: boolean;
};

/**
 * Голден скор, если так задан турнир, либо возраст старше 13 лет.
 * «До 13» включительно и явный хантей — судья выбирает победителя.
 * Возраст неизвестен: хантей, чтобы детский турнир не уехал в доп. время.
 */
export const usesGoldenScore = (
  rule: string | number | undefined,
  age?: AgeLimit | null
): boolean => {
  if (rule === MatchEndRule.GoldenScore || rule === 2) return true;
  if (rule === MatchEndRule.Hantei || rule === 1) return false;
  if (!age) return false;
  if (age.isOpenEnded || age.maxAge == null) return true;
  return age.maxAge > 13;
};
